/**
 * Состояния игры: IDLE, SPINNING, RESOLVING, SKULL, CASHOUT
 * Статичные круги заполняются по цветам; центральный барабан крутится.
 */

export type GameStateType =
  | 'IDLE'
  | 'SPINNING'
  | 'RESOLVING'
  | 'SKULL'
  | 'CASHOUT'
  | 'PARTIAL_CASHOUT';

export type RingColor = 'red' | 'green' | 'blue';

/** Заполненные множители по кругам (текущее состояние статичных кругов) */
export interface FilledSectors {
  red: number[];   // массив множителей в заполненных секторах красного круга
  green: number[];
  blue: number[];
}

export interface GameState {
  type: GameStateType;
  balance: number;
  bet: number;
  multiplier: number;
  payout: number;
  filledSectors: FilledSectors;
  lastResult?: { type: 'red' | 'green' | 'blue' | 'gray' | 'skull'; value?: number };
}

export const INITIAL_STATE: GameState = {
  type: 'IDLE',
  balance: 999.5,
  bet: 0.1,
  multiplier: 1,
  payout: 0,
  filledSectors: { red: [], green: [], blue: [] },
};
